import React from "react";
import { BsArrowRight } from "@react-icons/all-files/bs/BsArrowRight";
import { ButtonV2 } from "@Modules/common/ButtonV2";
import { classNames } from "repoV2/utils/common/render/classNames";
import styles from "./CTAButtonRender.module.scss";
import { ICTAButtonProps } from "./CTAButtonRender";

const CTAButtonRender = ({
    ctaText,
    showArrow,
    design,
    className,
    ...buttonProps
}: ICTAButtonProps) => {
    return (
        <ButtonV2
            className={classNames(
                styles.proceedButton,
                design === "secorndary"
                    ? styles.ctaButtonInvertedColourScheme
                    : styles.ctaButtonColourScheme,
                className
            )}
            {...buttonProps}
        >
            {ctaText}
            {showArrow && (
                <div className={styles.arrow}>
                    <BsArrowRight />
                </div>
            )}
        </ButtonV2>
    );
};

export default CTAButtonRender;
